<h1 class="matp-page-title">配送情報</h1>

<!-- タブ切り替え -->
<div class="tw-flex tw-my-2 tw-items-center tw-justify-between">
  <div class="shipment-tab-groups tw-flex tw-items-center">
    <mat-button-toggle-group
      class="matp-button-toggle-group matp-button-inactive"
      aria-label="配送ステータスタブ選択"
      [hideSingleSelectionIndicator]="'true'"
      [(ngModel)]="selectedTab"
      name="shipmentStatusTab"
    >
      <mat-button-toggle class="tw-w-32" value="notReady"
        >準備未完</mat-button-toggle
      >
      <mat-button-toggle class="tw-w-32" value="ready"
        >準備完了</mat-button-toggle
      >
      <mat-button-toggle class="tw-w-32" value="inProgress"
        >配送中</mat-button-toggle
      >
    </mat-button-toggle-group>

    <mat-button-toggle-group
      class="matp-button-toggle-group matp-button-inactive shipment-result-tab-group"
      aria-label="配送実績タブ選択"
      [hideSingleSelectionIndicator]="'true'"
      [(ngModel)]="selectedTab"
      name="shipmentResultTab"
    >
      <mat-button-toggle
        class="tw-w-40 shipment-result-tab-toggle"
        value="result"
        >配送実績</mat-button-toggle
      >
    </mat-button-toggle-group>
  </div>
</div>

<div [hidden]="selectedTab !== 'notReady'">
  <app-shipment-info-not-ready
    [shipmentList]="notReadyShipmentList"
    (opened)="openAlertAndMapDialogFromPreparation($event)"
  ></app-shipment-info-not-ready>
</div>

<div [hidden]="selectedTab !== 'ready'">
  <app-shipment-info-ready
    [shipmentList]="readyShipmentList"
    (opened)="openAlertAndMapDialogFromPreparation($event)"
  ></app-shipment-info-ready>
</div>

<div [hidden]="selectedTab !== 'inProgress'">
  <app-shipment-info-in-progress
    [shipmentList]="inProgressShipmentList"
    [routeLoading]="false"
    [defaultFilters]="defaultFilters"
    [editableRole]="editableRole"
    (opened)="openAlertAndMapDialog($event)"
    (statusGottenReady)="updateShipmentStatusReady($event)"
    (statusInterrupted)="updateShipmentStatusInterrupted($event)"
  ></app-shipment-info-in-progress>
</div>

<div [hidden]="selectedTab !== 'result'">
  <app-shipment-info-result
    [shipmentList]="resultShipmentList"
    [dateRangeFormGroup]="resultDateRangeFormGroup"
    [resultHistoryFrom]="getResultHistoryFromQuery()"
    [resultHistoryTo]="getResultHistoryToQuery()"
    [maxRangeMonths]="maxRangeMonths"
    [routeLoading]="
      resultRouteLoading || resultAlertLoading || resultSensorAlertLoading
    "
    [defaultFilters]="defaultFilters"
    [editableRole]="editableRole"
    (opened)="openAlertAndMapDialog($event)"
    (statusGottenReady)="updateShipmentStatusReady($event)"
    (statusInterrupted)="updateShipmentStatusInterrupted($event)"
    (searchRequested)="loadResultShipmentList()"
    (exportRequested)="exportResultShipmentListToCsv()"
  ></app-shipment-info-result>
</div>
